/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileProjectDetailInfo } from '../models/ProfileProjectDetailInfo';
import type { ProjectTokenInfo } from '../models/ProjectTokenInfo';
import type { TokenDetailInfo } from '../models/TokenDetailInfo';
import type { TokenPriceInfo } from '../models/TokenPriceInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProfileControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns TokenDetailInfo OK
     * @throws ApiError
     */
    public getProjectTokenDetail({
        tokenId,
    }: {
        tokenId: string,
    }): CancelablePromise<TokenDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/profile/token',
            query: {
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns TokenPriceInfo OK
     * @throws ApiError
     */
    public getTokenPrice({
        tokenId,
        period,
    }: {
        tokenId: string,
        period: 'DAY' | 'WEEK' | 'MONTH' | 'HALF' | 'YEAR' | 'YTD' | 'ALL',
    }): CancelablePromise<TokenPriceInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/profile/token/price',
            query: {
                'tokenId': tokenId,
                'period': period,
            },
        });
    }

    /**
     * @returns ProjectTokenInfo OK
     * @throws ApiError
     */
    public getProjectTokenList(): CancelablePromise<Array<ProjectTokenInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/profile/token/menu/list',
        });
    }

    /**
     * @returns ProfileProjectDetailInfo OK
     * @throws ApiError
     */
    public getProjectDetail(): CancelablePromise<ProfileProjectDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/profile/project',
        });
    }

}
